import * as React from "react";
import { Component } from "react";
import { Route, Switch } from "react-router";
import { BrowserRouter } from "react-router-dom";
import PageFooter from "./components/common/PageFooter";
import SolarWebNavbar from "./components/layout/SolarWebNavbar";
import "./css/App.css";
import { IAppState, IBaseProps } from "./interfaces";
import LoginPage from "./pages/auth/LoginPage";
import AccountPage from "./pages/projects/project/accounts/AccountPage";
import CompanyPage from "./pages/projects/project/accounts/CompanyPage";
import GuaranteedPowerTablePage from "./pages/projects/project/powerTable/GuaranteedPowerTablePage";
import ProjectPage from "./pages/projects/project/ProjectPage";
import AnnualSummaryByMonthReportPage from "./pages/projects/project/reports/AnnualSummaryByMonthReportPage";
import ExtendedAnnualSummaryByMonthReportPage from "./pages/projects/project/reports/ExtendedAnnualSummaryByMonthReportPage";
import AdvancedDualRateStatementPage from "./pages/projects/project/statements/advanced/dualrate/AdvancedDualRateStatementPage";
import AdvancedDualRateTablePage from "./pages/projects/project/statements/advanced/dualrate/AdvancedDualRateTablePage";
import AdvancedSingleRateStatementPage from "./pages/projects/project/statements/advanced/singlerate/AdvancedSingleRateStatementPage";
import AdvancedSingleRateTablePage from "./pages/projects/project/statements/advanced/singlerate/AdvancedSingleRateTablePage";
import SimpleDualRateStatementPage from "./pages/projects/project/statements/simple/dualrate/SimpleDualRateStatementPage";
import SimpleSingleRateStatementPage from "./pages/projects/project/statements/simple/singlerate/SimpleSingleRateStatementPage";
import StatementTemplatePage from "./pages/projects/project/templates/StatementTemplatePage";
import ProjectSettingsPage from "./pages/projects/ProjectSettingsPage";
import ProjectsPage from "./pages/projects/ProjectsPage";

export default class App extends Component<IBaseProps, IAppState> {
  private removeAuthListener: () => void;
  public constructor(props: IBaseProps) {
    super(props);

    this.authenticateUser = this.authenticateUser.bind(this);
    this.renderLoginPage = this.renderLoginPage.bind(this);
    this.renderProjects = this.renderProjects.bind(this);
    this.setLoadStatus = this.setLoadStatus.bind(this);
    this.renderProjectSettings = this.renderProjectSettings.bind(this);
    this.renderAccountPage = this.renderAccountPage.bind(this);
    this.renderProjectPage = this.renderProjectPage.bind(this);
    this.renderSupplyCompanyPage = this.renderSupplyCompanyPage.bind(this);
    this.renderDeliveryCompanyPage = this.renderDeliveryCompanyPage.bind(this);
    this.renderSimpleDualRateStatementPage = this.renderSimpleDualRateStatementPage.bind(this);
    this.renderSimpleSingleRateStatementPage = this.renderSimpleSingleRateStatementPage.bind(this);
    this.renderAdvancedSingleRateStatementPage = this.renderAdvancedSingleRateStatementPage.bind(
      this
    );
    this.renderAdvancedDualRateStatementPage = this.renderAdvancedDualRateStatementPage.bind(this);
    this.renderAnnualSummaryByMonthReportPage = this.renderAnnualSummaryByMonthReportPage.bind(
      this
    );
    this.renderGuaranteedPowerTablePage = this.renderGuaranteedPowerTablePage.bind(this);
    this.renderStatementTemplatesPage = this.renderStatementTemplatesPage.bind(this);
    this.renderAdvancedDualRateTablePage = this.renderAdvancedDualRateTablePage.bind(this);

    const { appService } = this.props;
    appService.setLoadStatus = this.setLoadStatus;

    this.state = { loading: true, user: null };
  }

  public componentWillMount() {
    const { appService } = this.props;
    this.removeAuthListener = appService
      .App()
      .auth()
      .onAuthStateChanged(user => {
        appService.setUser(user);
        if (user) {
          this.setState({
            loading: false,
            user,
          });
        } else {
          this.setState({
            loading: false,
            user: null,
          });
        }
        appService.setUser(user);
      });
  }
  public componentWillUnmount() {
    this.removeAuthListener();
  }
  public render() {
    if (this.state.loading) {
      return (
        <BrowserRouter>
          <div className="App">
            <SolarWebNavbar
              history={history}
              appService={this.props.appService}
              setUser={this.authenticateUser}
            />
          </div>
        </BrowserRouter>
      );
    }
    return (
      <BrowserRouter>
        <div className="App">
          <SolarWebNavbar
            history={history}
            appService={this.props.appService}
            setUser={this.authenticateUser}
          />
          <Switch>
            <Route // tslint:disable-next-line:jsx-no-lambda
              render={({ history, match }) => this.renderLoginPage(history, match)}
              path="/login"
            />
            <Route // tslint:disable-next-line:jsx-no-lambda
              render={({ history, match }) => this.renderProjects(history, match)}
              path="/"
              exact={true}
            />
            <Route // tslint:disable-next-line:jsx-no-lambda
              render={({ history, match }) => this.renderProjects(history, match)}
              path="/projects"
              exact={true}
            />
            <Route // tslint:disable-next-line:jsx-no-lambda
              render={({ history, match }) => this.renderProjectSettings(history, match)}
              path="/projectsettings/:id"
              exact={true}
            />
            <Route // tslint:disable-next-line:jsx-no-lambda
              render={({ history, match }) => this.renderAccountPage(history, match)}
              path="/account/:id"
              exact={true}
            />
            <Route // tslint:disable-next-line:jsx-no-lambda
              render={({ history, match }) => this.renderProjectPage(history, match)}
              path="/project/:id"
              exact={true}
            />
            <Route // tslint:disable-next-line:jsx-no-lambda
              render={({ history, match }) => this.renderSupplyCompanyPage(history, match)}
              path="/supplycompany/:id"
              exact={true}
            />
            <Route // tslint:disable-next-line:jsx-no-lambda
              render={({ history, match }) => this.renderDeliveryCompanyPage(history, match)}
              path="/deliverycompany/:id"
              exact={true}
            />
            <Route // tslint:disable-next-line:jsx-no-lambda
              render={({ history, match }) =>
                this.renderSimpleDualRateStatementPage(history, match)
              }
              path="/simpledualratestatement/:id"
              exact={true}
            />
            <Route // tslint:disable-next-line:jsx-no-lambda
              render={({ history, match }) =>
                this.renderSimpleSingleRateStatementPage(history, match)
              }
              path="/simplesingleratestatement/:id"
              exact={true}
            />
            <Route // tslint:disable-next-line:jsx-no-lambda
              render={({ history, match }) =>
                this.renderSimpleSingleRateStatementPage(history, match)
              }
              path="/simplesingleratestatement/:id/:priorId"
              exact={true}
            />
            <Route // tslint:disable-next-line:jsx-no-lambda
              render={({ history, match }) =>
                this.renderAdvancedSingleRateStatementPage(history, match)
              }
              path="/advancedsingleratestatement/:id"
              exact={true}
            />
            <Route // tslint:disable-next-line:jsx-no-lambda
              render={({ history, match }) =>
                this.renderAdvancedSingleRateStatementPage(history, match)
              }
              path="/advancedsingleratestatement/:id/:priorId"
              exact={true}
            />
            <Route // tslint:disable-next-line:jsx-no-lambda
              render={({ history, match }) =>
                this.renderAdvancedDualRateStatementPage(history, match)
              }
              path="/advanceddualratestatement/:id"
              exact={true}
            />
            <Route // tslint:disable-next-line:jsx-no-lambda
              render={({ history, match }) =>
                this.renderAdvancedDualRateStatementPage(history, match)
              }
              path="/advanceddualratestatement/:id/:priorId"
              exact={true}
            />
            <Route
              // tslint:disable-next-line:jsx-no-lambda
              render={({ history, match }) =>
                this.renderAnnualSummaryByMonthReportPage(history, match)
              }
              path="/annualsummarybymonthreport"
              exact={true}
            />
            <Route
              // tslint:disable-next-line:jsx-no-lambda
              render={({ history, match }) => this.renderGuaranteedPowerTablePage(history, match)}
              path="/guaranteedpowertable/:id"
              exact={true}
            />
            <Route
              // tslint:disable-next-line:jsx-no-lambda
              render={({ history, match }) => this.renderStatementTemplatesPage(history, match)}
              path="/statementTemplates/:id"
              exact={true}
            />
            <Route
              // tslint:disable-next-line:jsx-no-lambda
              render={({ history, match }) => this.renderAdvancedDualRateTablePage(history, match)}
              path="/advanceddualratetablepage"
              exact={true}
            />
            <Route
              // tslint:disable-next-line:jsx-no-lambda
              render={({ history, match }) =>
                this.renderAdvancedSingleRateTablePath(history, match)
              }
              path="/advancedsingleratetablepage"
              exact={true}
            />
            <Route
              // tslint:disable-next-line:jsx-no-lambda
              render={({ history, match }) =>
                this.renderExtendedAnnualSummaryByMonthReportPage(history, match)
              }
              path="/extendedannualsummarybymonthreport"
              exact={true}
            />
          </Switch>
          <PageFooter />
        </div>
      </BrowserRouter>
    );
  }
  private renderAdvancedSingleRateTablePath(history: any, match: any) {
    return (
      <AdvancedSingleRateTablePage
        appService={this.props.appService}
        history={history}
        match={match}
      />
    );
  }
  private renderAdvancedDualRateTablePage(history: any, match: any) {
    return (
      <AdvancedDualRateTablePage
        appService={this.props.appService}
        history={history}
        match={match}
      />
    );
  }

  private renderLoginPage(history: any, match: any) {
    return (
      <LoginPage
        appService={this.props.appService}
        setUser={this.authenticateUser}
        history={history}
      />
    );
  }
  private renderProjects(history: any, match: any) {
    return <ProjectsPage appService={this.props.appService} match={match} history={history} />;
  }
  private renderProjectSettings(history: any, match: any) {
    return (
      <ProjectSettingsPage appService={this.props.appService} match={match} history={history} />
    );
  }
  private renderAccountPage(history: any, match: any) {
    return <AccountPage appService={this.props.appService} match={match} history={history} />;
  }
  private renderProjectPage(history: any, match: any) {
    return <ProjectPage match={match} history={history} appService={this.props.appService} />;
  }
  private renderSupplyCompanyPage(history: any, match: any) {
    return (
      <CompanyPage
        match={match}
        history={history}
        appService={this.props.appService}
        companyType={0}
      />
    );
  }
  private renderDeliveryCompanyPage(history: any, match: any) {
    return (
      <CompanyPage
        match={match}
        history={history}
        appService={this.props.appService}
        companyType={1}
      />
    );
  }

  private renderSimpleDualRateStatementPage(history: any, match: any) {
    return (
      <SimpleDualRateStatementPage
        appService={this.props.appService}
        match={match}
        history={history}
      />
    );
  }

  private renderSimpleSingleRateStatementPage(history: any, match: any) {
    return (
      <SimpleSingleRateStatementPage
        appService={this.props.appService}
        match={match}
        history={history}
      />
    );
  }

  private renderAdvancedSingleRateStatementPage(history: any, match: any) {
    return (
      <AdvancedSingleRateStatementPage
        history={history}
        match={match}
        appService={this.props.appService}
      />
    );
  }

  private renderAdvancedDualRateStatementPage(history: any, match: any) {
    return (
      <AdvancedDualRateStatementPage
        history={history}
        match={match}
        appService={this.props.appService}
      />
    );
  }

  private renderAnnualSummaryByMonthReportPage(history: any, match: any) {
    return (
      <AnnualSummaryByMonthReportPage
        appService={this.props.appService}
        match={match}
        history={history}
      />
    );
  }

  private renderGuaranteedPowerTablePage(history: any, match: any) {
    return (
      <GuaranteedPowerTablePage
        appService={this.props.appService}
        history={history}
        match={match}
      />
    );
  }

  private renderStatementTemplatesPage(history: any, match: any) {
    return (
      <StatementTemplatePage appService={this.props.appService} history={history} match={match} />
    );
  }

  private authenticateUser(user: any, firstName?: string, lastName?: string): void {
    const { appService } = this.props;
    appService
      .setUser(user, firstName, lastName)
      .then(() => {
        setTimeout(() => {
          this.setState({ user, loading: false });
        }, 250);
      })
      .catch(error => {
        console.log(error);
      });
  }
  private setLoadStatus(loading: boolean) {
    this.setState({ loading });
  }

  private renderExtendedAnnualSummaryByMonthReportPage(history: any, match: any) {
    return (
      <ExtendedAnnualSummaryByMonthReportPage
        appService={this.props.appService}
        match={match}
        history={history}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.tsx